<template>
    <div id="app">
        <keep-alive>
            <NewNewMenu
                v-if="
                    $route.name == 'swipe' ||
                        $route.name == 'swipe-slug' ||
                        $route.name == 'swipe-image' ||
                        $route.name == 'index-dev' ||
                        $route.name == 'images-dev' ||
                        $route.name == 'studio-dev' ||
                        $route.name == 'studio-image-dev' ||
                        $route.name == 'project-list-books' ||
                        $route.name == 'project-list-websites' ||
                        $route.name == 'project-list-typefaces' ||
                        $route.name == 'project-list-identities' ||
                        $route.name == 'project-detail' ||
                        $route.name == 'splash-dev'
                "
            ></NewNewMenu>
            <NewMenu v-else></NewMenu>
        </keep-alive>
        <!--
            <transition name="fade" mode="out-in">
                <SplashPage v-if="store.splashPage"></SplashPage>
            </transition>
        -->
        <!--
            <transition name="fade" mode="out-in" appear>
        -->

        <router-view
            class="newContainer"
            v-if="
                $route.name == 'swipe' ||
                    $route.name == 'swipe-slug' ||
                    $route.name == 'swipe-image' ||
                    $route.name == 'index-dev' ||
                    $route.name == 'images-dev' ||
                    $route.name == 'studio-dev' ||
                    $route.name == 'studio-image-dev' ||
                    $route.name == 'project-list-books' ||
                    $route.name == 'project-list-websites' ||
                    $route.name == 'project-list-typefaces' ||
                    $route.name == 'project-list-identities' ||
                    $route.name == 'project-detail' ||
                    $route.name == 'splash-dev'
            "
        />
        <keep-alive v-else :exclude="['Detail']">
            <router-view :key="$route.fullPath" />
        </keep-alive>
        <!--
            </transition>
        -->
    </div>
</template>

<script>
import { store } from "@/centralStore";
import api from "@/api";
import SplashPage from "@/components/SplashPage";
import NewMenu from "@/components/NewMenu";
import NewNewMenu from "@/components/NewNewMenu";

export default {
    name: "app",
    components: {
        SplashPage,
        NewMenu,
        NewNewMenu
    },
    data() {
        return {
            store: store.state
        };
    },
    //watch: {
    //'$route' (to, from) {
    //if (from.name.includes('detail') && to.name == 'index'){
    //this.store.detailTransition = 'slideUp'
    //} else {
    //this.store.detailTransition = ''
    //}
    //}
    //},
    //watch: {
    //'$route' (to, from) {
    //const toDepth = to.path.split('/').length
    //const fromDepth = from.path.split('/').length
    //this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    //this.transitionName = 'slideUp'
    //}

    //},

    // watch: {
    //     '$route'(to, from) {
    //         console.log(from)
    //         // Code
    //     }
    // },
    methods: {
        shuffle(a) {
            for (let i = a.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [a[i], a[j]] = [a[j], a[i]];
            }
            return a;
        },
        getImages(arr, idx, items) {
            var fwd = arr
                .filter(function(v, i) {
                    return i >= idx;
                })
                .slice(0, items);
            var newIdx = items - fwd.length;

            while (fwd.length < items) {
                fwd = fwd.concat(arr).slice(0, items);
            }
            return { arr: fwd, idx: newIdx };
        },
        getHeight() {
            const doc = document.documentElement;
            doc.style.setProperty(
                "--app-height",
                `${document.documentElement.clientHeight}px`
            );
        }
        //addToArray(arr, images, idx, amount){
        //var result = this.getImages(images, idx, amount);
        //arr = arr.concat(result.arr);
        //var returnIdx = result.idx;
        //return returnIdx
        //},
    },
    mounted() {
        // console.log("app", this.store.afterSplashId);
        // console.log("app", this.store.afterSplashSlug);
        var myself = this;
        if (this.$route.name == "detail-slug" && this.$route.from == null) {
            // console.log('da')
            this.store.random = false;
        }

        (function(a) {
            if (
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                    a
                ) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                    a.substr(0, 4)
                )
            )
                myself.store.isMobile = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        api.get("projects/")
            .then(response => {
                myself.store.allProjects = response.data;
                myself.store.projects = myself.store.allProjects.filter(
                    p =>
                        p.category.name != "Typeface (Project)" &&
                        p.category.name != "Visual Identity (Project)"
                );
                myself.store.projects = myself.store.projects.sort((a, b) => {
                    if (myself.store.sorting == "type") {
                        if (a.category.name < b.category.name) {
                            return -1 * myself.store.sortingOrder;
                        }
                        if (a.category.name > b.category.name) {
                            return 1 * myself.store.sortingOrder;
                        }
                    } else {
                        if (a[myself.store.sorting] < b[myself.store.sorting]) {
                            return -1 * myself.store.sortingOrder;
                        }
                        if (a[myself.store.sorting] > b[myself.store.sorting]) {
                            return 1 * myself.store.sortingOrder;
                        }
                    }
                    return 0;
                });
                //myself.store.totalImages = myself.projects.reduce((acc, cur) => {
                //return cur.images.length + acc.images.length;
                //})
                //myself.shuffle(myself.store.projects);
                var counter = 1;
                var images = [];
                var allImages = [];
                var pairMark = false;
                //let projectIdx = 0;
                //let projectImageCounter = 1;
                myself.store.projects.forEach(project => {
                    project.images.forEach(img => {
                        img.counter = counter;
                        allImages.push(img);
                        if (!pairMark || window.innerWidth <= 8) {
                            //if (projectIdx != img.project){
                            //projectImageCounter = 1;
                            //projectIdx = img.project;
                            //} else {
                            //projectImageCounter += 1;
                            //}
                            //img.projectCounter = projectImageCounter;
                            images.push(img);
                            counter += 1;
                        } else {
                            pairMark = false;
                        }
                        if (img.is_paired_with_next && window.innerWidth > 8) {
                            pairMark = true;
                        }
                    });
                });
                myself.store.orderedImages = images;
                //allImages.forEach(image => {
                //let img = new Image;
                //img.src = image.thumbnail_med;
                //img.onload = () => {
                //image.width = img.width
                //image.height = img.height
                //}
                //})
                myself.store.allImages = allImages;
                myself.store.totalImages = images.length;
                //var TLImages = images.filter(image => image.level == 'TL');
                var BOImages = images.filter(image => image.level == "BO");
                var PMImages = images.filter(image => image.level == "PM");
                var TYImages = images.filter(image => image.level == "TY");
                var DIImages = images.filter(image => image.level == "DI");
                var SPImages = images.filter(image => image.level == "SP");
                var MLImages = images.filter(image => image.level == "ML");
                //var LLImages = images.filter(image => image.level == 'LL');
                //console.log('BO', BOImages)
                //console.log('PM', PMImages)
                //console.log('TY', TYImages)
                //console.log('DI', DIImages)
                //console.log('SP', SPImages)

                myself.shuffle(BOImages);
                myself.shuffle(PMImages);
                myself.shuffle(TYImages);
                myself.shuffle(DIImages);
                myself.shuffle(SPImages);
                myself.shuffle(MLImages);
                //myself.shuffle(LLImages);

                let images20 = [];
                let images40 = [];
                let images60 = [];

                //var BOIdx = 0;
                //var PMIdx = 0;
                //var TYIdx = 0;
                //var DIIdx = 0;
                //var SPIdx = 0;
                //var MLIdx = 0;
                //var LLIdx = 0;

                //var resultTL = myself.getImages(TLImages, TLIdx, 6);
                //var resultML = myself.getImages(MLImages, MLIdx, 4);
                var resultBO = BOImages.slice(0, 5);
                var resultPM = PMImages.slice(0, 5);
                var resultTY = TYImages.slice(0, 5);
                var resultDI = DIImages.slice(0, 3);
                var resultSP = SPImages.slice(0, 2);
                //var resultML = MLImages.slice(0, 20);
                //resultTL= myself.shuffle(resultTL);
                //TLIdx = resultTL.idx;
                //MLIdx = resultML.idx;
                images20 = images20.concat(
                    resultBO,
                    resultPM,
                    resultTY,
                    resultDI,
                    resultSP
                );
                let images20Shuffle = myself.shuffle(images20);
                console.log(
                    "images20",
                    images20Shuffle.map(i => i.level)
                );
                //images10 = images10.slice(0,1).concat(myself.shuffle(images10.slice(1, 10)));

                //resultTL = myself.getImages(TLImages, TLIdx, 4);
                //resultML = myself.getImages(MLImages, MLIdx, 6);
                //resultTL = TLImages.slice(6, 10);
                //resultML = MLImages.slice(4, 10);
                var resultBO = BOImages.slice(5, 10);
                var resultPM = PMImages.slice(5, 10);
                var resultTY = TYImages.slice(5, 10);
                var resultDI = DIImages.slice(3, 6);
                var resultSP = SPImages.slice(3, 5);
                //TLIdx = resultTL.idx;
                //MLIdx = resultML.idx;
                images40 = images40.concat(
                    resultBO,
                    resultPM,
                    resultTY,
                    resultDI,
                    resultSP
                );
                let images40Shuffle = myself.shuffle(images40);
                console.log(
                    "images40",
                    images40Shuffle.map(i => i.level)
                );

                //resultTL = myself.getImages(TLImages, TLIdx, 2);
                //resultML = myself.getImages(MLImages, MLIdx, 5);
                //resultTL = TLImages.slice(10, 12);
                //resultML = MLImages.slice(10, 15);
                var resultML = MLImages.slice(0, 20);
                //var resultLL = myself.getImages(LLImages, LLIdx, 3);
                //var resultLL = LLImages.slice(0, 3);
                //TLIdx = resultTL.idx;
                //MLIdx = resultML.idx;
                //LLIdx = resultLL.idx;
                images60 = images60.concat(resultML);

                let images60Shuffle = myself.shuffle(images60);
                console.log(
                    "images60",
                    images60Shuffle.map(i => i.level)
                );

                //resultTL = myself.getImages(TLImages, TLIdx, 1);
                //resultML = myself.getImages(MLImages, MLIdx, 7);
                //resultLL = myself.getImages(LLImages, LLIdx, 12);
                //resultTL = TLImages.slice(12, 13);
                //resultML = MLImages.slice(15, 22);
                //resultLL = LLImages.slice(3, 15);
                //TLIdx = resultTL.idx;
                //MLIdx = resultML.idx;
                //LLIdx = resultLL.idx;
                //images40 = images40.concat(resultTL, resultML, resultLL);
                //images40 = myself.shuffle(images40);

                //console.log('20', images20)
                //console.log('40', images40)
                //console.log('60', images60)

                let finalImages = images20Shuffle.concat(
                    images40Shuffle,
                    images60Shuffle
                );
                // console.log(finalImages)
                let restImages = [];
                images.forEach(i => {
                    if (!finalImages.includes(i)) {
                        restImages.push(i);
                    }
                });
                let restImagesShuffle = myself.shuffle(restImages);
                let finalfinalImages = images20Shuffle.concat(
                    images40Shuffle,
                    images60Shuffle,
                    restImagesShuffle
                );
                myself.store.shuffledImages = finalfinalImages;
                // myself.store.shuffledImages = finalImages;
                //myself.store.swipeImages = images;
                myself.store.swipeImages = myself.store.shuffledImages;

                console.log(
                    "swipeImages",
                    myself.store.swipeImages.map(i => [i.level, i.id])
                );
                //myself.store.shuffledImages.forEach((image, idx) => {
                //console.log(idx+1, image.level, image.image)
                //})
                //myself.store.shuffledImages.forEach(image => console.log(image.level, image.id));
                myself.store.imagesReady = true;
            })
            .catch(function(error) {
                // handle error
                console.log(error);
            });
        window.addEventListener("resize", myself.getHeight);
        myself.getHeight();
    }
};
</script>

<style>
@font-face {
    font-family: "JMMP Regular";
    src: url("assets/JMMP-Regular.woff");
}

@font-face {
    font-family: "JMMP Text";
    src: url("assets/JMMP-Text.woff");
}

@font-face {
    font-family: "JMMP Medium";
    src: url("assets/JMMP-Medium.woff");
}

@font-face {
    font-family: "JMMP Display";
    src: url("assets/JMMP-Display.woff");
}

@font-face {
    font-family: "JMMP Regular Tab";
    src: url("assets/JMMP-Tab-Regular.woff");
}

@font-face {
    font-family: "Arena";
    src: url("assets/Arena_0-22GX.ttf") format("truetype-variations");
}

@font-face {
    font-family: "JMMP Regular New";
    src: url("assets/new_font/JMMP-Regular.woff2");
}
@font-face {
    font-family: "JMMP Regular Italic New";
    src: url("assets/new_font/JMMP-RegularItalic.woff2");
}

:root {
    --app-height: 100%;
}

html {
    /*font-size: 3.75vw;*/
    /*font-size: 2.5vw;*/
    font-size: 3.125vw;
    background-color: black;
    height: 100%;
}

@media screen and (min-width: 768px) {
    html {
        /*font-size: 1.11vw;*/
        font-size: 16px;
    }
}

@media screen and (min-width: 1920px) {
    html {
        font-size: 0.83vw;
    }
}

body {
    margin: 0;
    font-family: "JMMP Text";
    /* font-feature-settings: "ss01" on; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow: auto;
    font-size: 1.25rem;
    background-color: black;
    overscroll-behavior: none;
    height: 100%;
}

body.index {
    overflow: hidden;
}

@media screen and (min-width: 768px) {
    body {
        font-size: 0.75rem;
    }
}

#app {
    margin: 0;
    /*color: #232323;*/
    color: white;
    background-color: black;
    transition: background-color 0.5s;
    height: 100%;
    /*background-color: rgba(0,0,0,0);*/
}
.newContainer {
    font-family: "JMMP Regular New";
    line-height: 1.25;
}

/*.invertedBack{
    background-color: rgba(0,0,0,100%) !important;
    transition: background-color .5s;
}*/

/*.slideUp-enter-active,
.slideUp-leave-active{
    transition: 1s;
}

.slideUp-enter{
    transform: translate(0, 100%)
}
.slideUp-leave-to{
    transform: translate(0, -100%)
}

*/

/*
.slideDown-leave-active,
.slideDown-enter-active{
    transition: 1s;
}

.slideDown-enter{
    transform: translateY(-100%);
}
.slideDown-enter-to{
    transform: translateY(0%);
}
.slideDown-leave{
    transform: translateY(0%);
}
.slideDown-leave-to{
    transform: translateY(-100%);
}
*/
.tabNum {
    font-variant-numeric: tabular-nums;
}

.fade-enter-active {
    /*transition: opacity .05s;*/
    transition: opacity 0.25s;
}

.fade-leave-active {
    /*transition: opacity .05s;*/
    transition: opacity 0s;
}

.fade-enter {
    opacity: 0.5;
}

.fade-enter-to {
    opacity: 1;
}

.fade-leave {
    opacity: 1;
}

.fade-leave-to {
    opacity: 1;
}
</style>
